<template>
    <img src="@/assets/powered_by_ewn.svg"
         v-if="isBrandingLoaded && isBranded"
         class="powered-by-logo"
         :alt="$t('ewn.logo-alt')" />
</template>

<script>
  import { computed, defineComponent } from 'vue';
  import { useStore } from '@/store';

  export default defineComponent({
    name: 'PoweredByLogo',
    setup () {
      const store = useStore();

      return {
        isBranded: computed(() => store.state.branding.isBranded),
        isBrandingLoaded: computed(() => store.state.branding.isBrandingLoaded)
      };
    }
  });
</script>

<style lang="scss">

  .powered-by-logo {
    display: block;
    height: 60px;
    margin: 0 auto;
    margin-top: 32px;
  }

</style>
